import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import CustomButton from "components/CustomButton";
import { forwardRef, useEffect, useState } from "react";
import { useForm, useWatch } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import CheckRole from "components/CheckRole";
import { DEPARTMENT_MANAGER, MANAGER } from "config/roles";
import http from "../../../http";
import { setShowLoading, setShowMassage } from "store/sysSlice";
import { apiUrl, boUrl, webAppUrl } from "config/settings";
import moment from "moment";
import useDataManager from "hooks/useDataManager";
import { setCallBackData, setList, setServicesCallDetails } from "store/servicesCallSlice";
import CustomMenu from "components/CustomMenu";
import { AssistantPhoto, Close, EditCalendar, Outbox, SaveAlt, Summarize } from "@mui/icons-material";
import CustomIconButton from "components/CustomIconButton";
import { ST_TYPE, ST_TYPE_ID, endpointName } from "../const";
import Global from "./tabs/Global";
import Payments from "./tabs/Payments";
import Providers from "./tabs/Providers";
import CustomTabs from "components/CustomTabs";
import { BIZ_TYPE } from "config/const";
import { createGoogleCalendarLink, currencyFormat, lineText } from "config/functions";
import NullCheck from "components/NullCheck";
import SupplierCosts from "./tabs/SupplierCosts";
import CustomCard from "components/CustomCard";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Slide,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import Media from "./tabs/Media";
import Preparations from "./tabs/Preparations";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Details = () => {
  const theme = useTheme()
  const { editItem, removeItem } = useDataManager();
  const dispatch = useDispatch();
  const { bt } = useBizTypeTranslation();
  const { reset, handleSubmit, control, watch, setValue, clearErrors, formState: { errors } } = useForm();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const biz = useSelector((state) => state.biz?.data);
  const list = useSelector((state) => state?.servicesCall.list);
  const details = useSelector((state) => state?.servicesCall.servicesCallDetails);
  const employeeslist = useSelector((state) => state?.employees?.list);
  const userRole = useSelector((state) => state.userSettings?.user?.userRole);
  const [data, setData] = useState(null);
  const [empList, setEmpList] = useState([]);
  const [workDt, setWorkDt] = useState(null);
  const [workEndDt, setWorkEndDt] = useState(null);
  const [selectedTab, setSelectedTab] = useState(0);
  const [totalSupplierCosts, setTotalSupplierCosts] = useState(0);

  const [toolList, setToolList] = useState([])
  const [partslist, setPartslist] = useState([])
  const [worksList, setWorksList] = useState([])
  const [replacedPartsList, setReplacedPartsList] = useState([])

  const pmtTypeId = watch("pmtTypeId");
  const stTypeId = watch("stTypeId");
  const price = watch("price");

  const supplierCosts = useWatch({ control, name: "supplierCosts" });

  useEffect(() => {
    setToolList(data?.tools || [])
    setPartslist(data?.parts || [])
    setWorksList(data?.works || [])
    setReplacedPartsList(data?.replacedParts || [])
  }, [data])

  useEffect(() => {
    setTotalSupplierCosts(supplierCosts?.reduce((acc, curr) => acc + (curr.price * curr.qty || 0), 0) || 0)
  }, [supplierCosts]);

  const menuOptions = [
    {
      title: data?.hasFlag ? "REMOVE_HAS_FALG" : "ADD_HAS_FALG",
      icon: <AssistantPhoto />,
      show: true,
      onClick: () => editHasFlag({ call: data, hasFlag: data?.hasFlag ? false : true }),
    },
    {
      title: "CREATE_GOOGLE_CALENDAR",
      icon: <EditCalendar />,
      show: true,
      onClick: () => createGoogleCalendar(data),
    },
    {
      title: "OPEN_SEVICES_SUMMARY",
      icon: <Summarize />,
      show: true,
      onClick: () => openSummary(),
    },
    {
      title: "SEND_SEVICES_SUMMARY",
      icon: <Outbox fontSize="small" />,
      show: true,
      onClick: () => sendSummary(),
    },
    {
      title: "SUBMIT_AND_SEND_SUMMARY",
      icon: <SaveAlt fontSize="small" />,
      show: true,
      onClick: () => handleSubmit(onSubmit)({ sendSummary: true }),
    },
  ];

  const TABS = [
    { id: 0, title: 'GLOBAL' },
    { id: 1, title: 'הכנות', bizType: BIZ_TYPE.SERVICE_PROVIDER },
    { id: 2, title: 'PROVIDERS_AND_PAYMENTS', bizType: BIZ_TYPE.SERVICE_PROVIDER, hide: isMobile || !MANAGER.includes(userRole) },
    { id: 3, title: 'MEDIA', hide: !biz?.hasServiceMedia },
  ]

  useEffect(() => {
    const handlePopState = (e) => {
      if (data) {
        e.preventDefault();
        onClose();
      }
    };

    if (data) {
      window.history.pushState(null, "", window.location.href);
      window.addEventListener("popstate", handlePopState);
    }

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [data]);

  useEffect(() => {
    if (details) {
      getservicesCall(details?._id)
    }
  }, [details])

  useEffect(() => {
    setEmpList(
      employeeslist?.filter(e => e.isBoAllowed)?.map((emp) => {
        return { id: emp?.id, name: `${emp?.fn} ${emp?.ln}` };
      })
    );
  }, [employeeslist]);

  useEffect(() => {
    reset({
      ...data,
      contentWithItems: data?.contentWithItems?.length > 0
        ? data?.contentWithItems.map(item => item.trim())
        : [""],
    });

    if (data?.workDt)
      setWorkDt(moment(data?.workDt));
  }, [data]);

  useEffect((dt) => {
    setWorkEndDt(moment(dt).add(1, 'hour'))
  }, [workDt])

  const onClose = () => {
    setSelectedTab(0)
    dispatch(setServicesCallDetails(null))
    setData(null)
  };

  const handleDialogClose = (event, reason) => {
    if (reason === "escapeKeyDown") onClose();
  }

  const getservicesCall = (id) => {
    dispatch(setShowLoading(true))
    http.get(`${apiUrl}/${endpointName}/${id}`).then((res) => {
      dispatch(setShowLoading(false))
      setData({ ...res?.data?.data, useCallBack: data?.useCallBack })
    }).catch(error => {
      dispatch(setShowLoading(false))
      dispatch(setShowMassage({ massage: "GET_SERVICE_CALL_ERROR", type: "error" }));
    })
  }

  const sendSummary = () => {
    dispatch(setShowLoading(true));
    http.post(`${apiUrl}/${endpointName}/servicesSummarySendEmail/${data.id}`)
      .then((res) => {
        dispatch(setShowLoading(false));
        if (res.data?.id === 1) {
          dispatch(
            setShowMassage({
              massage: "SEND_SUCCESS",
              type: "success",
            })
          );
        } else if (res.data?.id === -5) {
          dispatch(
            setShowMassage({
              massage: "CLIENT_NO_EMAIL",
              type: "error",
            })
          );
        }
      })
      .catch((error) => {
        console.error("error", error);
      });
  };

  const openSummary = () => {
    window.open(`${webAppUrl}/Services-Summary/${biz.path}/${data.id}`, "_blank");
  };

  const createGoogleCalendar = (call) => {
    const startDt = call?.workDt || moment()
    const endDt = call?.workEndDt
      ? call?.workEndDt
      : call?.workDt
        ? moment(call?.workDt).add(1, 'hour')
        : moment().add(1, 'hour')

    const contentWithItems = data?.contentWithItems && data?.contentWithItems[0] !== ""
      ? data?.contentWithItems?.map((item, index) => item)
      : null

    const descriptionLines = [
      contentWithItems ? contentWithItems : null,
      " ",
      `${bt('GOOGLE_CALENDAR_SERVICE_DESCRIPTION')}:`,
      `${boUrl}/Service-Call/Active/${call?.callId}`,
    ]
      .filter(Boolean)
      .join("\n");

    const link = createGoogleCalendarLink({
      title: `${bt('GOOGLE_CALENDAR_SERVICE_TITLE')}: ${call?.callId} | ${call.clienCompany} | ${call?.addr}`,
      // location: call?.addr,
      description: descriptionLines,
      start: startDt,
      end: endDt,
    })
    window.open(link, '_blank')
  }

  const editHasFlag = (data) => {
    if (!data?.call?._id) return

    dispatch(setShowLoading(true));
    let obj = { hasFlag: data?.hasFlag }

    http.patch(`${apiUrl}/${endpointName}/${data?.call?._id}`, obj)
      .then((res) => {
        dispatch(setShowLoading(false));
        const item = { ...data?.call, ...obj };
        const newList = editItem(item, list);
        dispatch(setList(newList));
        setData(prev => ({ ...prev, hasFlag: data?.hasFlag }))
        dispatch(setShowMassage({ massage: data?.hasFlag ? "ADD_HAS_FALG_SUCCESS" : "REMOVE_HAS_FALG_SUCCESS", type: "success" }));
      })
      .catch((error) => {
        dispatch(setShowLoading(false));
      });
  }

  const onSubmit = (values, extraData) => {
    if (worksList && worksList?.length > 0) {
      const continual = worksList[worksList?.length - 1]?.continual
      if (continual && values?.stTypeId == ST_TYPE_ID.CLOSE)
        return dispatch(setShowMassage({ massage: "SERVICE_CALL_CONTINUAL_ERROR", type: "error" }));
    }

    dispatch(setShowLoading(true));

    let obj = {
      isRead: true,
      approval: values?.stTypeId === ST_TYPE_ID.CLOSE ? values?.approval ?? false : false,
      notes: values?.notes,
      clientCallId: values?.clientCallId,
      stTypeId: values?.stTypeId,
      workDt: workDt,
      workEndDt: workEndDt ?? null,
      addr: values?.addr,
      tel: values?.tel,
      name: values?.name,
      color: values?.color,
      pmtTypeId: values?.pmtTypeId,
      price: values?.price,
      employee: values?.employee,
      orderNum: values?.orderNum,
      invoiceNum: values?.invoiceNum,
      taxInvoiceNum: values?.taxInvoiceNum,
      quotationNum: values?.quotationNum,
      contentWithItems: values?.contentWithItems,
      supplierCosts: values?.supplierCosts,
      providersExpenses: values?.supplierCosts?.reduce((acc, curr) => acc + (curr.price * curr.qty || 0), 0) || 0,
    };

    http.patch(`${apiUrl}/${endpointName}/${data?.id}`, obj)
      .then((res) => {
        dispatch(setShowLoading(false));
        let newList = []

        if (extraData.sendSummary)
          sendSummary()

        const item = {
          _id: data?.id,
          ...data,
          isRead: true,
          approval: values?.approval ?? false,
          notes: values?.notes ?? data?.notes,
          clientCallId: values?.clientCallId,
          stTypeId: values?.stTypeId ?? data?.stTypeId,
          workEndDt: workEndDt ?? null,
          addr: values?.addr ?? data?.addr,
          tel: values?.tel ?? data?.tel,
          name: values?.name ?? data?.name,
          contentWithItems: values?.contentWithItems ?? data?.contentWithItems,
          pmtTypeId: values?.pmtTypeId ?? data?.pmtTypeId,
          providers: values?.providers ?? data?.providers,
          color: values?.color ?? data?.color,
          price: values?.price ?? data?.price,
          orderNum: values?.orderNum ?? data?.orderNum,
          invoiceNum: values?.invoiceNum ?? data?.invoiceNum,
          taxInvoiceNum: values?.taxInvoiceNum ?? data?.taxInvoiceNum,
          quotationNum: values?.quotationNum ?? data?.quotationNum,
          employee: values?.employee ?? data?.employee,
          supplierCosts: values?.supplierCosts || data?.supplierCosts,
          providersExpenses: values?.supplierCosts?.reduce((acc, curr) => acc + (curr.price * curr.qty || 0), 0) || 0,
        };

        if (data?.useCallBack) dispatch(setCallBackData(item));
        if (values?.stTypeId === ST_TYPE_ID.CLOSE) newList = removeItem(data?.id, list);
        else newList = editItem(item, list);
        dispatch(setList(newList));
        onClose();

      })
      .catch((error) => {
        dispatch(setShowLoading(false));
      });
  };

  return (
    <Dialog
      open={data ? true : false}
      fullScreen={isMobile ? true : false}
      TransitionComponent={Transition}
      onClose={handleDialogClose}
      sx={{
        padding: 0,
        "& .MuiDialog-paper": {
          width: "100%",
          bgcolor: "bgPage.main",
          // minWidth: {} isMobile ? '100%' : 900,
          minWidth: { xs: '100%', md: 700, xl: 900 },
          overflow: 'hidden',
          borderRadius: isMobile ? 0 : 3,
        },
        "& .MuiBackdrop-root": {
          bgcolor: "rgba(0 , 0, 0, 0.1)",
          backdropFilter: "blur(2px)",
        },
      }}
    >
      <form
        style={{
          width: "100%",
          display: "flex",
          flexDirection: 'column',
          justifyContent: 'space-between',
          height: isMobile ? '100%' : '90vh',
          overflow: 'hidden'
        }}
        onSubmit={handleSubmit(onSubmit)}
      >

        <DialogTitle sx={{ borderBottom: "1px solid black", padding: 0 }}>
          <Stack
            padding={1}
            direction='row'
            alignItems='center'
            justifyContent='space-between'
          >
            <Stack alignItems='center' direction='row' spacing={5} >

              <Stack direction="row" alignItems='center' spacing={1}>

                <CheckRole role={DEPARTMENT_MANAGER}>
                  <CustomMenu
                    anchorOrigin={{ horizontal: 'right' }}
                    transformOrigin={{ horizontal: 'right' }}
                    options={menuOptions}
                  />
                </CheckRole>

                <NullCheck valueForCheck={data?.hasFlag}>
                  <AssistantPhoto color="warning" />
                </NullCheck>

                <Typography fontSize={{ xs: 14, md: 16 }} fontWeight='bold'>
                  {`${bt("SERVICES_CALL")} - ${data?.callId}`}
                </Typography>
              </Stack>

              <Stack direction="row" spacing={2}>
                <CustomIconButton
                  icon={<SaveAlt fontSize="small" sx={{ color: "bgPage.main" }} />}
                  onClick={() => handleSubmit(onSubmit)({ sendSummary: true })}
                  size={30}
                />

                <CustomIconButton
                  icon={<EditCalendar fontSize="small" sx={{ color: "bgPage.main" }} />}
                  onClick={() => createGoogleCalendar(data)}
                  size={30}
                />
              </Stack>
            </Stack>

            <CustomIconButton
              hideBgcolor
              iconColor="primary.text"
              size={30}
              icon={<Close />}
              onClick={onClose}
            />
          </Stack>

          <CustomTabs
            tabList={TABS}
            scrollAmount={20}
            callBackFunc={(e) => setSelectedTab(e)}
          />
        </DialogTitle>

        <DialogContent sx={{ height: "100%", overflow: 'auto', padding: 0 }}>
          <Stack width="100%" height="100%" padding={{ xs: 1, md: 2 }}>

            {/* Client Details */}
            {selectedTab === 0
              ? <Global
                control={control}
                data={data}
                errors={errors}
                setWorkDt={setWorkDt}
                setValue={setValue}
                watch={watch}
                workDt={workDt}
                empList={empList}
                stTypeId={stTypeId}
                workEndDt={workEndDt}
                isMobile={isMobile}
                editHasFlag={editHasFlag}
                setWorksList={setWorksList}
                worksList={worksList}
                replacedPartsList={replacedPartsList}
                setReplacedPartsList={setReplacedPartsList}
              />
              : selectedTab === 1
                ? <Stack spacing={2} pb={2}>
                  <Preparations
                    control={control}
                    data={data}
                    errors={errors}
                    pmtTypeId={pmtTypeId}
                    toolList={toolList}
                    setToolList={setToolList}
                    partslist={partslist}
                    setPartslist={setPartslist}
                  />
                </Stack>
                : selectedTab === 2
                  ? <Stack spacing={2} pb={2}>

                    <CustomCard spacing={0.1}>
                      <Typography fontSize={14}>{bt("FINANCIAL_SUMMARY")}:</Typography>

                      <Stack width='100%' direction={{ xs: "column", md: "row" }} justifyContent="space-between">
                        <Typography color='error.text'>
                          {`${bt("SUPPLIER_COSTS")}: ${currencyFormat(totalSupplierCosts || 0)}`}
                        </Typography>

                        <Typography>
                          {`${bt("INCOME")}: ${currencyFormat(price || 0)}`}
                        </Typography>

                        <Typography
                          color={((price || 0) - (totalSupplierCosts || 0)) > 0 ? 'green' : 'error.text'}
                        >
                          {`${bt(((price || 0) - (totalSupplierCosts || 0)) > 0 ? "PROFIT" : "LOSS")}: ${currencyFormat(Math.abs((price || 0) - (totalSupplierCosts || 0)))}`}
                        </Typography>
                      </Stack>
                    </CustomCard>

                    <Payments
                      control={control}
                      data={data}
                      errors={errors}
                      pmtTypeId={pmtTypeId}
                    />

                    <Providers
                      data={data}
                      control={control}
                      errors={errors}
                    />

                    <SupplierCosts
                      setValue={setValue}
                      watch={watch}
                      control={control}
                      data={data}
                      errors={errors}
                      totalSupplierCosts={totalSupplierCosts}
                    />

                  </Stack>
                  : selectedTab === 3
                    ? <Media
                      clearErrors={clearErrors}
                      data={data}
                      setData={setData}
                      setList={setList}
                      list={list}
                    />
                    : null
            }
          </Stack>
        </DialogContent>

        <DialogActions
          sx={{
            padding: 1,
            flexDirection: "column",
            justifyContent: isMobile ? "space-between" : 'end',
            alignItems: "center",
            gap: 1.5,
            borderTop: "1px solid black",
          }}
        >
          <Stack width='100%' direction='row' spacing={1}>
            {ST_TYPE?.map((st, idx) => {
              const stTypeId = watch('stTypeId')
              return (
                <CustomButton
                  key={idx}
                  title={st?.name}
                  fullWidth
                  color='secondary'
                  onClick={() => setValue("stTypeId", st?.id)}
                  variant={stTypeId === st?.id ? "contained" : "outlined"}
                />
              )
            })}
          </Stack>


          <Stack width='100%' direction='row' spacing={1}>
            <CustomButton
              fullWidth
              height={45}
              color="error.main"
              textColor="error.text"
              title="CLOSE"
              onClick={onClose}
            />

            <CustomButton
              fullWidth
              title="SAVE"
              height={45}
              color="success.main"
              textColor="success.text"
              submit
            />
          </Stack>
        </DialogActions>
      </form>
    </Dialog >
  );
};

export default Details;
